export default __webpack_public_path__ + "static/media/remove_item.920e101a.svg";